import React, { useState } from "react";
import { Modal, Button, Select, Form, Row, Col } from "antd";
import Button_v2 from "./Button_v2";

const SuborderModal = ({
  isVisible,
  onClose,
  onSave,
  screenType,
  consolidatedData,
  orderResponse,
  orgData,
  setIsLoading,
}) => {
  const [formValues, setFormValues] = useState({
    order_numbers: [],
    hawb_numbers: [],
  });

  const handleSelectChange = (value, field) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      [field]: value,
    }));
  };

  const handleSave = (formValues) => {
    // Implement your save logic here
    const linkdelinktext = screenType === "subOrdersView" ? "link" : "delink";
    onSave(formValues, linkdelinktext);
  };

  const modalContent = () => {
    return (
      <>
        <div className="table-container-shipper ">
          <span className="modal-content">
            Linked Orders and HAWBs must be from the same account (ShipStuff,
            INC).
          </span>
        </div>
        <Row>
          <Col className="InputFieldHeight table-col marginTop8">
            <Form.Item label="Order #" className="custom-form-item">
              <Select
                value={
                  _.isArray(formValues.order_numbers)
                    ? _.compact(formValues.order_numbers)
                    : []
                }
                onChange={(val) => handleSelectChange(val, "order_numbers")}
                mode="tags"
                style={{ width: "100%" }}
                showSearch
                filterOption={(input, option) =>
                  option.props.children
                    .toLowerCase()
                    .indexOf(input.toLowerCase()) >= 0
                }
                placeholder="Enter or select order number"
                maxTagCount={4}
              >
                {screenType === "orderViewSidebar" &&
                  consolidatedData.map((order) => (
                    <Select.Option
                      key={order.customer_order_id}
                      value={order.customer_order_number}
                    >
                      {order.customer_order_number}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>
          </Col>
        </Row>

        {screenType !== "orderViewSidebar" && (
          <Row>
            <Col className="InputFieldHeight table-col marginTop8">
              <Form.Item label="HAWB" className="custom-form-item">
                <Select
                  value={
                    _.isArray(formValues.hawb_numbers)
                      ? _.compact(formValues.hawb_numbers)
                      : []
                  }
                  onChange={(val) => handleSelectChange(val, "hawb_numbers")}
                  mode="tags"
                  style={{ width: "100%" }}
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  placeholder="Enter or select HAWB number"
                  maxTagCount={4}
                ></Select>
              </Form.Item>
            </Col>
          </Row>
        )}
      </>
    );
  };
  const modalFooter = () => {
    return (
      <>
        <Button_v2
          key="cancel"
          text="Cancel"
          className="flat medium-btn"
          onClick={onClose}
        />
        <Button_v2
          key="confirm"
          text={
            screenType === "orderViewSidebar" ? "Delink Orders" : "Link Orders"
          }
          type="primary"
          className="raised medium-btn"
          onClick={() => handleSave(formValues)}
        />
      </>
    );
  };
  const Text =
    screenType === "orderViewSidebar"
      ? "Delink Existing Orders"
      : "Link Existing Orders";
  return (
      <Modal
      className="suborder-modal"
      visible={isVisible}
      onCancel={onClose}
      title={Text}
      width={530}
      centered={true}
      footer={modalFooter()}
    >
      {modalContent()}
    </Modal>
  );
};

export default SuborderModal;

//     [
//     <Button key="cancel" onClick={onClose}>
//       Cancel
//     </Button>,
//     <Button key="confirm" type="primary" onClick={handleSave}>
//       Link Orders
//     </Button>,
//   ]

{
  /* <div className="table-container-shipper">
        <span className="modal-content">
          Linked Orders and HAWBs must be from the same account (ShipStuff, INC).
        </span>
      </div>
      <Row>
        <Col className="InputFieldHeight table-col marginTop8">
          <Form.Item label="Order #" className="custom-form-item">
            <Select
              value={formValues.order_numbers}
              onChange={(val) => handleSelectChange(val, 'order_numbers')}
              mode="tags"
              style={{ width: '100%' }}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              placeholder="Enter or select order number"
              maxTagCount={4}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col className="InputFieldHeight table-col marginTop8">
          <Form.Item label="HAWB" className="custom-form-item">
            <Select
              value={formValues.hawb_numbers}
              onChange={(val) => handleSelectChange(val, 'hawb_numbers')}
              mode="tags"
              style={{ width: '100%' }}
              showSearch
              filterOption={(input, option) =>
                option.children.toLowerCase().includes(input.toLowerCase())
              }
              placeholder="Enter or select HAWB number"
              maxTagCount={4}
            />
          </Form.Item>
        </Col>
      </Row> */
}
